document.addEventListener('alpine:init', () => {
  Alpine.data('skinQuiz', () => ({
    firstName: '',
    currentStep: 0,
    emailStep: false,
    completed: false,
    triedBefore: 'no',
    answers: {},
    score: 70,
    isTransitioning: false,
    transitionClass: '',
    questions: [
      {
        id: 1,
        step: 1,
        text: 'What is your age?',
        options: [
          { id: '18_25', text: '18 - 25' },
          { id: '26_35', text: '26 - 35' },
          { id: '35_45', text: '35 - 45' },
          { id: '45_60', text: '45 - 60' },
          { id: '60_plus', text: '60+' },
        ],
      },
      {
        id: 2,
        step: 2,
        text: 'What does a typical meal look like?',
        options: [
          { id: 'chicken_salad', text: 'Chicken and salad' },
          { id: 'burgers_fries', text: 'Burgers and fries' },
          { id: 'frozen_food', text: 'Frozen food' },
          { id: 'beer_takeout', text: 'Beer and take out' },
        ],
      },
      {
        id: 3,
        step: 3,
        text: 'How many hours of sleep do you get a night?',
        options: [
          { id: '1_4', text: '1 - 4' },
          { id: '5_6', text: '5 - 6' },
          { id: '7_plus', text: '7+' },
        ],
      },
      {
        id: 4,
        step: 4,
        text: 'How many glasses of water do you drink daily?',
        options: [
          { id: '1_3', text: '1 - 3' },
          { id: '4_5', text: '4 - 5' },
          { id: '6_7', text: '6 - 7' },
          { id: '8_plus', text: '8+' },
        ],
      },
      {
        id: 5,
        step: 5,
        text: 'At the end of the day, does your face look:',
        options: [
          { id: 'dry_parched', text: 'Dry or parched' },
          { id: 'same_as_morning', text: 'Same as when you woke up' },
          { id: 'oily_shiny', text: 'Oily or shiny' },
        ],
      },
      {
        id: 6,
        step: 6,
        text: 'How often do you exfoliate?',
        options: [
          { id: 'every_day', text: 'Every day' },
          { id: 'weekly', text: 'Weekly' },
          { id: 'few_times_month', text: 'A few times a month' },
          { id: 'never', text: 'Never' },
        ],
      },
      {
        id: 7,
        step: 7,
        text: 'Do you smoke?',
        options: [
          { id: 'yes', text: 'Yes' },
          { id: 'no', text: 'No' },
        ],
      },
      {
        id: 8,
        step: 8,
        text: 'What about your skin would you most like to improve?',
        options: [
          { id: 'fine_lines_wrinkles', text: 'Fine lines and wrinkles' },
          { id: 'daily_skincare', text: 'Daily skincare' },
          { id: 'discoloration_complexion', text: 'Discoloration/complexion' },
          { id: 'oily_skin_pores', text: 'Oily skin/pores' },
        ],
      },
      {
        id: 9,
        step: 9,
        text: 'What does your current skin care routine look like?',
        options: [
          { id: 'no_routine', text: "I don't have one" },
          { id: 'face_wash_only', text: 'I use some face wash' },
          { id: 'basic_routine', text: 'I wash my face, moisturize, and maybe use a few other products' },
          { id: 'full_routine', text: 'I have a full routine that includes daily skin care and anti aging' },
        ],
      },
      {
        id: 10,
        step: 10,
        text: "Have you tried Brickell Men's products before?",
        options: [
          { id: 'yes', text: 'Yes' },
          { id: 'no', text: 'No' },
        ],
      },
    ],

    productMapping: {
      trigger1: {
        'dry_parched': [301155971],
        'same_as_morning': [6585082806347],
        'oily_shiny': [450323531],
      },
      trigger2: {
        'every_day': [422934903],
        'weekly': [422934903],  
        'few_times_month': [422934903],
        'never': [422934903],
      },
      trigger3: {
        'fine_lines_wrinkles': [331270471, 6585110626379],
        'daily_skincare': [301080227, 6939974271051],
        'discoloration_complexion': [6939975188555, 1509091082315],
        'oily_skin_pores': [1331683885131, 1509091082315],
      }
    },

    visibleProducts: [],

    init() {
      window.addEventListener('quiz-finish', (event) => {
        this.firstName = event.detail.firstName;
        this.finish()
      });

      var urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('retake') === '1') {
        window.history.replaceState({}, document.title, window.location.pathname);
        this.reset();
        return;
      }

      if (urlParams.get('test') === '1') {
        var trigger1 = urlParams.get('trigger1') || 'same_as_morning'; // Default to 'same_as_morning' if not provided
        var trigger2 = urlParams.get('trigger2') || 'never';
        var trigger3 = urlParams.get('trigger3') || 'fine_lines_wrinkles';
        this.triedBefore = urlParams.get('tried') || 'no';

        Cookies.remove('score');
        this.score = this.getOrSetScore();
        this.completed = true;
        this.firstName = 'Tester';
        this.toggleProductVisibility(trigger1, trigger2, trigger3);
        this.renderBundlers();
        return;
      }

      if (Cookies.get('taken')) {
        this.completed = true;
        const trigger1Answer = Cookies.get('trigger1');
        const trigger2Answer = Cookies.get('trigger2');
        const trigger3Answer = Cookies.get('trigger3');

        this.score = this.getOrSetScore();
        this.firstName = Cookies.get('firstName') || '';
        this.toggleProductVisibility(trigger1Answer, trigger2Answer, trigger3Answer);
        this.renderBundlers();
      }
    },

    start() {
      this.currentStep = 1;
    },

    selectOption(option) {
      if (this.isTransitioning) return;
      if (document.activeElement && document.activeElement.classList && document.activeElement.classList.contains('option-btn')) {
        document.activeElement.blur();
      }
      const question = this.questions[this.currentStep - 1];
      this.answers[question.id] = option.id;
      this.isTransitioning = true;
      this.transitionClass = 'is-exiting';

      setTimeout(() => {
        if (this.currentStep < this.questions.length) {
          this.currentStep++;
        } else {
          this.currentStep++;
          this.emailStep = true;
        }
        this.$nextTick(() => {
          if (document.activeElement && document.activeElement.blur) {
            document.activeElement.blur();
          }
          if (this.$refs.question && this.$refs.question.focus) {
            this.$refs.question.focus({ preventScroll: true });
            this.$refs.question.blur();
          }
          if (this.emailStep) {
            this.transitionClass = '';
            this.isTransitioning = false;
            return;
          }

          this.transitionClass = 'is-entering';
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              setTimeout(() => {
                this.transitionClass = '';
                this.isTransitioning = false;
              }, 120);
            });
          });
        });
      }, 220);
    },

    prevStep() {
      if (this.currentStep > 1) {
        this.currentStep--;
      }
    },

    getOrSetScore(){
      if (Cookies.get('score')) {
        return Cookies.get('score');
      }

      var score = Math.floor(Math.random() * 11) + 70; 
      Cookies.set('score', score);
      return score;
    },

    toggleProductVisibility(trigger1Answer, trigger2Answer, trigger3Answer) {
      if (this.productMapping.trigger1[trigger1Answer]) {
        this.visibleProducts.push(...this.productMapping.trigger1[trigger1Answer]);
      }

      if (this.productMapping.trigger2[trigger2Answer]) {
        this.visibleProducts.push(...this.productMapping.trigger2[trigger2Answer]);
      }

      if (this.productMapping.trigger3[trigger3Answer]) {
        this.visibleProducts.push(...this.productMapping.trigger3[trigger3Answer]);
      }
    },

    reset() {
      Cookies.remove('taken');
      Cookies.remove('trigger1');
      Cookies.remove('trigger2');
      Cookies.remove('trigger3');
      Cookies.remove('triedBefore');
      Cookies.remove('score');
      Cookies.remove('firstName');

      this.currentStep = 0;
      this.emailStep = false;
      this.completed = false;
      this.answers = {};
      this.visibleProducts = [];
      this.firstName = '';
    },

    renderBundlers() {
      const rechargeContainer = document.querySelector('#recharge-bundles');
      const quizContainer = document.querySelector('#quiz-section-container');

      // 1. & 2. Handle Promo Templates (v2b and Template B)
      if ((window.v2btemplate || window.btemplate) && this.triedBefore === 'no') {
        
        if (window.v2btemplate) {
          document.body.classList.add('results-with-new-customer-offer');
        } else {
          document.body.classList.add('results-with-kit');
        }

        // EXPLICITLY HIDE everything related to the bundler
        if (rechargeContainer) {
          rechargeContainer.style.display = 'none';
        }
        if (quizContainer) {
          quizContainer.classList.remove('with-bundle');
        }
        // Hide any other potential bundler wrappers
        document.querySelectorAll('.bundler-section-toggle').forEach(el => {
            // We only want to show the product grid, not the bundler UI
            if (el.id === 'build-a-box' || el.contains(rechargeContainer)) {
                el.style.display = 'none';
            }
        });
      } 
      
      // 3. Default logic (Recharge Bundle)
      else {
        document.body.classList.add('results-with-bundle');

      // Load Recharge Config
      window.BoxConfig = {
        template: 'product',
        designMode: false,
        layoutTemplate: "one-page",
        product: {"id":7461466013771,"title":"Subscription Routine Bundler","handle":"subscription-routine-bundler","description":null,"published_at":"2026-02-09T13:30:11-05:00","created_at":"2025-10-20T11:34:19-04:00","vendor":"Brickell Men's Products®","type":"hidden","tags":["Hidden recommendation","hidden_product","one_time_offer","SEARCHANISE_IGNORE"],"price":0,"price_min":0,"price_max":0,"available":true,"price_varies":false,"compare_at_price":null,"compare_at_price_min":0,"compare_at_price_max":0,"compare_at_price_varies":false,"variants":[{"id":41836076990539,"title":"Default Variant","option1":"Default Variant","option2":null,"option3":null,"sku":null,"requires_shipping":true,"taxable":true,"featured_image":null,"available":true,"name":"Subscription Routine Bundler - Default Variant","public_title":"Default Variant","options":["Default Variant"],"price":0,"weight":0,"compare_at_price":null,"inventory_quantity":-1,"inventory_management":null,"inventory_policy":"continue","barcode":null,"requires_selling_plan":false,"selling_plan_allocations":[{"price_adjustments":[{"position":1,"price":0}],"price":0,"compare_at_price":0,"per_delivery_price":0,"selling_plan_id":1542848587,"selling_plan_group_id":"12d55eca2768089b9282160b789b601ff23b1e93"},{"price_adjustments":[{"position":1,"price":0}],"price":0,"compare_at_price":0,"per_delivery_price":0,"selling_plan_id":1542946891,"selling_plan_group_id":"6c45eee619efe23969118f5abb9d14e05c1b1422"},{"price_adjustments":[{"position":1,"price":0}],"price":0,"compare_at_price":0,"per_delivery_price":0,"selling_plan_id":1542914123,"selling_plan_group_id":"21632555a188edd685d6d9bcdb3f4bdbc7cbbed0"}],"quantity_rule":{"min":1,"max":null,"increment":1}}],"images":["\/\/brickellmensproducts.com\/cdn\/shop\/files\/sas-bundle.png?v=1761596339"],"featured_image":"\/\/brickellmensproducts.com\/cdn\/shop\/files\/sas-bundle.png?v=1761596339","options":["Title"],"media":[{"alt":null,"id":25431021289547,"position":1,"preview_image":{"aspect_ratio":1.0,"height":1200,"width":1200,"src":"\/\/brickellmensproducts.com\/cdn\/shop\/files\/sas-bundle.png?v=1761596339"},"aspect_ratio":1.0,"height":1200,"media_type":"image","src":"\/\/brickellmensproducts.com\/cdn\/shop\/files\/sas-bundle.png?v=1761596339","width":1200}],"requires_selling_plan":false,"selling_plan_groups":[{"id":"12d55eca2768089b9282160b789b601ff23b1e93","name":"Delivery every 30 days","options":[{"name":"Recharge Plan ID","position":1,"values":["19988647"]},{"name":"Order Frequency and Unit","position":2,"values":["30-day"]},{"name":"Product Quantity","position":3,"values":["0"]}],"selling_plans":[{"id":1542848587,"name":"Delivery every 30 days","description":null,"options":[{"name":"Recharge Plan ID","position":1,"value":"19988647"},{"name":"Order Frequency and Unit","position":2,"value":"30-day"},{"name":"Product Quantity","position":3,"value":"0"}],"recurring_deliveries":true,"price_adjustments":[{"order_count":null,"position":1,"value_type":"percentage","value":0}],"checkout_charge":{"value_type":"percentage","value":100}}],"app_id":"294517"},{"id":"6c45eee619efe23969118f5abb9d14e05c1b1422","name":"Delivery every 60 days","options":[{"name":"Recharge Plan ID","position":1,"values":["19988649"]},{"name":"Order Frequency and Unit","position":2,"values":["60-day"]},{"name":"Product Quantity","position":3,"values":["0"]}],"selling_plans":[{"id":1542946891,"name":"Delivery every 60 days","description":null,"options":[{"name":"Recharge Plan ID","position":1,"value":"19988649"},{"name":"Order Frequency and Unit","position":2,"value":"60-day"},{"name":"Product Quantity","position":3,"value":"0"}],"recurring_deliveries":true,"price_adjustments":[{"order_count":null,"position":1,"value_type":"percentage","value":0}],"checkout_charge":{"value_type":"percentage","value":100}}],"app_id":"294517"},{"id":"21632555a188edd685d6d9bcdb3f4bdbc7cbbed0","name":"Delivery every 90 days","options":[{"name":"Recharge Plan ID","position":1,"values":["19988650"]},{"name":"Order Frequency and Unit","position":2,"values":["90-day"]},{"name":"Product Quantity","position":3,"values":["0"]}],"selling_plans":[{"id":1542914123,"name":"Delivery every 90 days","description":null,"options":[{"name":"Recharge Plan ID","position":1,"value":"19988650"},{"name":"Order Frequency and Unit","position":2,"value":"90-day"},{"name":"Product Quantity","position":3,"value":"0"}],"recurring_deliveries":true,"price_adjustments":[{"order_count":null,"position":1,"value_type":"percentage","value":0}],"checkout_charge":{"value_type":"percentage","value":100}}],"app_id":"294517"}],"content":null}
      };

        // Only inject script if it doesn't exist
        if (!document.querySelector('script[src*="bundling-widget"]')) {
          const script = document.createElement('script');
          script.src = 'https://static.rechargecdn.com/assets/bundling-widget/src.js';
          script.defer = true;
          script.referrerPolicy = 'origin';
          document.body.appendChild(script);
        }

        if (rechargeContainer) {
          rechargeContainer.style.display = 'block';
        }
        if (quizContainer) {
          quizContainer.classList.add('with-bundle');
        }
      }

      // 4. FINAL STEP: Make sure the recommended products (the grid) are visible
      // We target the product grid specifically to avoid showing the bundler UI
      const productGrid = document.querySelector('#product-grid');
      if (productGrid) {
          // If the grid is inside a toggled section, show that section
          const parentToggle = productGrid.closest('.bundler-section-toggle');
          if (parentToggle) {
              parentToggle.style.display = 'block';
          }
          productGrid.style.display = 'flex'; // Ensure the grid itself is visible
      }
    },

    finish() {
      this.completed = true;
      var trigger1Answer = this.answers[5]; // Question 5: "At the end of the day, does your face look:"
      var trigger2Answer = this.answers[6]; // Question 6: "How often do you exfoliate?"
      var trigger3Answer = this.answers[8]; // Question 8: "What about your skin would you most like to improve?"
      var triedBefore = this.answers[10]; // Question 10: "Have you tried Brickell Men's products before?"
      this.score = this.getOrSetScore();

      Cookies.set('taken', 1);
      Cookies.set('trigger1', trigger1Answer);
      Cookies.set('trigger2', trigger2Answer);
      Cookies.set('trigger3', trigger3Answer);
      Cookies.set('triedBefore', triedBefore);
      Cookies.set('firstName', this.firstName);

      this.toggleProductVisibility(trigger1Answer, trigger2Answer, trigger3Answer); 
      this.renderBundlers();

      // Scroll to the top
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }));
});
